import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@softline/core';

export interface Deactivateable {
  canDeactivate(): Promise<boolean>
}

@Injectable()
export class LeaveArtikelAuswahlGuard {

  constructor(private store: Store, private router: Router) {}

  async canDeactivate(
    component: Deactivateable,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Promise<boolean> {
    if(nextState?.url === '/llr-bskomm/bestellungen')
      return await component.canDeactivate();
    return true;
  }
}
